<template>
  <div class="index">
    <van-nav-bar title="淋巴瘤诊疗观念调研3" fixed left-arrow @click-left="$router.go(-1)" />
    <div class="index-head">淋巴瘤诊疗观念调研3</div>
    <!--  -->
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="105px" class="form" label-position="left">
      <div class="box">
        <div class="box-head">
          <div class="box-head-title">
            为了进一步推动CAR-T疗法在LBCL治疗中的规范化管理，特诚邀血液肿瘤领域的各位专业医师参与本次调研。本问卷旨在了解当前国内CAR-T细胞治疗的临床应用现状，以及医师们对LBCL治疗的诊疗观念。</div>
          <ul class="box-head-ul">
            <li class="box-head-ul-li">1. 本次调研所有信息仅用于学术研究，不涉及商业用途。</li>
            <li class="box-head-ul-li">2. 请根据实际情况作答，确保所填信息的完整性和准确性，请勿虚构数据或歪曲事实。</li>
            <li class="box-head-ul-li">3. 患者的个人信息将匿名处理，确保隐私安全。</li>
            <li class="box-head-ul-name">本问卷预计耗时约20分钟，感谢您的耐心填写。</li>
          </ul>
          <div>
            <div class="form-head-input">
              <el-form-item class="form-dis-item" label="医生姓名：" prop="name">
                <el-input v-model="form.name" placeholder="请输入医生姓名" :disabled="true" />
              </el-form-item>
              <el-form-item class="form-dis-item" label="所在医院：" prop="hospital">
                <el-input v-model="form.hospital" placeholder="请输入所在医院" :disabled="true" />
              </el-form-item>
              <el-form-item class="form-dis-item" label="所在科室：" prop="department">
                <el-input v-model="form.department" placeholder="请输入所在科室" :disabled="true" />
              </el-form-item>
              <el-form-item label="职称：" prop="title" class="form-dis-item-left">
                <el-input v-model="form.title" placeholder="请输入职称" :disabled="true" />
              </el-form-item>
            </div>
            <div class="form-dis-box">
              <el-form-item label="医院级别：" prop="rank">
                <el-radio-group v-model="form.rank" class="form-dis-radio" :disabled="true">
                  <el-radio :label="1">一级</el-radio>
                  <el-radio :label="2">二级</el-radio>
                  <el-radio :label="3">三级</el-radio>
                  <el-radio :label="4" style="margin-top: 15px;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-dis-box-radio">
                <el-form-item prop="rank_input" v-if="form.rank == 4">
                  <el-input v-model="form.rank_input" placeholder="请输入内容" :disabled="true" />
                </el-form-item>
              </div>
            </div>
            <div class="form-dis-box">
              <el-form-item label="医院性质：" prop="property" style="margin-bottom: 0;">
                <el-radio-group v-model="form.property" class="form-dis-radio2" :disabled="true">
                  <el-radio :label="1" style="margin-right: 13px;">综合性医院</el-radio>
                  <el-radio :label="2">肿瘤专科医院</el-radio>
                  <el-radio :label="3" style="margin-right: 200px;margin-top: 15px;">民营/私立医院</el-radio>
                  <el-radio :label="4" style="margin-top: 15px;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-dis-box-radio2">
                <el-form-item prop="property_input" v-if="form.property == 4">
                  <el-input v-model="form.property_input" placeholder="请输入内容" :disabled="true" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 1 -->
        <div class="form-item">
          <el-form-item label="1、绝大多数情况下，患者是否了解过CAR-T治疗？" prop="lymph3_treat_radio" ref="lymph3_treat_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph3_treat_radio" :disabled="true">
              <el-radio :label="1">非常了解</el-radio>
              <el-radio :label="2">略有了解</el-radio>
              <el-radio :label="3">完全不了解</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 2 -->
        <div class="form-item">
          <el-form-item label="2、您通常如何评估患者是否适合进行CAR-T治疗？（可多选）" prop="lymph3_estimate_checkbox"
            ref="lymph3_estimate_checkbox" class="box-dis">
            <el-checkbox-group v-model="form.lymph3_estimate_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">基因分型和分子检测</el-checkbox>
              <el-checkbox label="2" name="type">临床症状和治疗反应</el-checkbox>
              <el-checkbox label="3" name="type">影像学评估</el-checkbox>
              <el-checkbox label="4" name="type">综合评估，包括患者意愿和预期疗效</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph3_estimate_checkbox_input"
            ref="lymph3_estimate_checkbox_input" v-if="form.lymph3_estimate_checkbox.includes('5') == true">
            <el-input v-model="form.lymph3_estimate_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 3 -->
        <div class="form-item">
          <el-form-item label="3、您认为CAR-T疗法对淋巴瘤治疗的最大优势是什么（可多选）？" prop="lymph3_superiority_checkbox"
            ref="lymph3_superiority_checkbox" class="box-dis">
            <el-checkbox-group v-model="form.lymph3_superiority_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">高疗效，尤其是对于复发难治性患者</el-checkbox>
              <el-checkbox label="2" name="type">相对较少的副作用</el-checkbox>
              <el-checkbox label="3" name="type">个体化治疗的优势</el-checkbox>
              <el-checkbox label="4" name="type">长期缓解率较高</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph3_superiority_checkbox_input"
            ref="lymph3_superiority_checkbox_input" v-if="form.lymph3_superiority_checkbox.includes('5') == true">
            <el-input v-model="form.lymph3_superiority_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 4 -->
        <div class="form-item">
          <el-form-item label="4、您认为CAR-T治疗的未来发展方向是什么？" prop="lymph3_direction_radio" ref="lymph3_direction_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph3_direction_radio" :disabled="true">
              <el-radio :label="1">扩展适应症，适用于更多类型的淋巴瘤</el-radio>
              <el-radio :label="2" style="margin: 20px 0 0px 0;">改善副作用管理，减少细胞因子风暴和神经毒性</el-radio>
              <el-radio :label="3" style="margin: 20px 0 0px 0;">提高疗效和持久性</el-radio>
              <el-radio :label="4" style="margin: 20px 0 0px 0;">新型CAR-T细胞的开发，如“自体”或“异体”CAR-T</el-radio>
              <el-radio :label="5" style="margin: 20px 0 12px 0;">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph3_direction_radio_input"
            ref="lymph3_direction_radio_input" v-if="form.lymph3_direction_radio == 5">
            <el-input v-model="form.lymph3_direction_radio_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 5 -->
        <div class="form-item form-item-error">
          <el-form-item label="5、绝大多数情况下，患者是否愿意参与CAR-T相关的临床试验？" prop="lymph3_trial_radio" ref="lymph3_trial_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph3_trial_radio" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">不确定</el-radio>
              <el-radio :label="3">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 6 -->
        <div class="form-item">
          <el-form-item label="6、您认为CAR-T治疗对淋巴瘤患者的长期生存率有何影响？" prop="lymph3_influence_radio" ref="lymph3_influence_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph3_influence_radio" :disabled="true">
              <el-radio :label="1">显著提高长期生存率</el-radio>
              <el-radio :label="2" style="margin: 20px 0 0px 0;">有一定提高，但需要长期观察</el-radio>
              <el-radio :label="3" style="margin: 20px 0 0px 0;">对长期生存影响较小</el-radio>
              <el-radio :label="4" style="margin: 20px 0 12px 0;">目前尚无明确数据，难以评估</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 7 -->
        <div class="form-item">
          <el-form-item label="7、对于CAR-T治疗中的免疫逃逸现象，您认为哪些策略值得研究（可多选）？" prop="lymph3_study_checkbox"
            ref="lymph3_study_checkbox" class="box-dis">
            <el-checkbox-group v-model="form.lymph3_study_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">联合其他免疫疗法，如PD-1抑制剂</el-checkbox>
              <el-checkbox label="2" name="type">进一步优化CAR-T细胞设计</el-checkbox>
              <el-checkbox label="3" name="type">定期监测免疫逃逸，及时调整治疗方案</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="4" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph3_study_checkbox_input"
            ref="lymph3_study_checkbox_input" v-if="form.lymph3_study_checkbox.includes('4') == true">
            <el-input v-model="form.lymph3_study_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 8 -->
        <div class="form-item">
          <el-form-item label="8、CAR-T治疗的副作用管理上，您认为最具挑战性的是哪方面（多选）？" prop="lymph3_challenge_checkbox"
            ref="lymph3_challenge_checkbox" class="box-dis">
            <el-checkbox-group v-model="form.lymph3_challenge_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">细胞因子风暴（CRS）</el-checkbox>
              <el-checkbox label="2" name="type">神经毒性</el-checkbox>
              <el-checkbox label="3" name="type">感染风险</el-checkbox>
              <el-checkbox label="4" name="type">造血抑制</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph3_challenge_checkbox_input"
            ref="lymph3_challenge_checkbox_input" v-if="form.lymph3_challenge_checkbox.includes('5') == true">
            <el-input v-model="form.lymph3_challenge_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 9 -->
        <div class="form-item">
          <el-form-item label="9、如果接受CAR-T治疗，患者更希望了解哪方面的信息（可多选）？" prop="lymph3_information_checkbox"
            ref="lymph3_information_checkbox" class="box-dis">
            <el-checkbox-group v-model="form.lymph3_information_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">疗效和成功率</el-checkbox>
              <el-checkbox label="2" name="type">潜在风险和副作用</el-checkbox>
              <el-checkbox label="3" name="type">治疗费用和报销途径</el-checkbox>
              <el-checkbox label="4" name="type">治疗过程细节</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <!-- 10 -->
        <div class="form-item form-item-error">
          <el-form-item label="10、您是否认为需要更大范围普及CAR-T治疗知识？" prop="lymph3_knowledge_radio" ref="lymph3_knowledge_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph3_knowledge_radio" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 11 -->
        <div class="form-item">
          <el-form-item label="11、您认为CAR-T治疗对于不同淋巴瘤亚型的疗效差异如何（可多选）？" prop="lymph3_difference_checkbox"
            ref="lymph3_difference_checkbox" class="box-dis">
            <el-checkbox-group v-model="form.lymph3_difference_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">DLBCL效果最好</el-checkbox>
              <el-checkbox label="2" name="type">整体疗效差异不大</el-checkbox>
              <el-checkbox label="3" name="type">依赖于个体差异</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="4" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph3_difference_checkbox_input"
            ref="lymph3_difference_checkbox_input" v-if="form.lymph3_difference_checkbox.includes('4') == true">
            <el-input v-model="form.lymph3_difference_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 12 -->
        <div class="form-item">
          <el-form-item label="12、您认为未来淋巴瘤治疗的发展趋势是什么（可多选）？" prop="lymph3_trend_checkbox" ref="lymph3_trend_checkbox"
            class="box-dis">
            <el-checkbox-group v-model="form.lymph3_trend_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">A.精准医学和基因治疗</el-checkbox>
              <el-checkbox label="2" name="type">免疫疗法和细胞疗法的应用</el-checkbox>
              <el-checkbox label="3" name="type">新型靶向药物的研发</el-checkbox>
              <el-checkbox label="4" name="type">多学科联合治疗模式</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph3_trend_checkbox_input"
            ref="lymph3_trend_checkbox_input" v-if="form.lymph3_trend_checkbox.includes('5') == true">
            <el-input v-model="form.lymph3_trend_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 16 -->
        <!-- <div class="form-item"></div> -->
        <!-- 结束 -->
        <div class="dibu">
          <div class="dibu-img"><img src="@/assets/image/survey/anquan.png"></div>
          <div class="dibu-name">隐私保护</div>
        </div>
        <div style="margin-bottom: 10px;">您提供的个人信息和回答将仅用于统计分析和研究。</div>
        <div>非常感谢您抽出宝贵时间参与本次调查，您的意见和建议对我们非常重要！</div>
        <!-- 按钮 -->
        <!-- <div class="btn">
          <el-form-item class="btn-form">
            <el-button style="width: 100%; border-radius:18px;" type="primary"
              @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </div> -->
      </div>
    </el-form>
    <!--  -->
  </div>
</template>  
<script>
export default {
  name: 'survey3',
  data() {
    return {
      form: {
        name: '', //姓名
        hospital: '',//医院  
        department: '',//科室
        title: '',//职称 
        rank: '',//级别
        rank_input: '',//级别其他
        property: '',//性质 
        property_input: '',//性质其他
        //@@@@@@@@@@@@@@@@@@@@@@@@@@@@
        lymph3_treat_radio: '',//治疗   

        lymph3_estimate_checkbox: [],//car-t评估治疗
        lymph3_estimate_checkbox_input: '',//car-t评估治疗输入框  

        lymph3_superiority_checkbox: [],//car-t优势
        lymph3_superiority_checkbox_input: '',//car-t优势输入框 

        lymph3_direction_radio: [],//car-t发展方向
        lymph3_direction_radio_input: '',//car-t发展方向输入框

        lymph3_trial_radio: '',//试验

        lymph3_influence_radio: '',//影响6 

        lymph3_study_checkbox: [],//研究7
        lymph3_study_checkbox_input: '',//研究输入框

        lymph3_challenge_checkbox: [],//挑战8
        lymph3_challenge_checkbox_input: '',//挑战输入框

        lymph3_information_checkbox: [],//信息9

        lymph3_knowledge_radio: '',//知识10

        lymph3_difference_checkbox: [],//差异11 
        lymph3_difference_checkbox_input: '',//差异输入框

        lymph3_trend_checkbox: [],//趋势11 
        lymph3_trend_checkbox_input: '',//趋势输入框 
      },
      rules: {
        name: [{ required: true, message: '请输入医生姓名', trigger: 'blur' },],
        hospital: [{ required: true, message: '请输入所在医院', trigger: 'blur' }],
        department: [{ required: true, message: '请输入所在科室', trigger: 'blur' }],
        title: [{ required: true, message: '请输入所职称', trigger: 'blur' }],
        rank: [{ required: true, message: '请选择医院级别', trigger: 'change' }],
        rank_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        property: [{ required: true, message: '请选择医院性质', trigger: 'change' }],
        property_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@   
        lymph3_treat_radio: [{ required: true, message: '请选择患者是否了解过CAR-T治疗', trigger: 'change' }],

        lymph3_estimate_checkbox: [{ required: true, message: '请选择您通常如何评估患者是否适合进行CAR-T治疗', trigger: 'change' }],
        lymph3_estimate_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph3_superiority_checkbox: [{ required: true, message: '请选择最大优势是什么', trigger: 'change' }],
        lymph3_superiority_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        lymph3_direction_radio: [{ required: true, message: '请选择未来发展方向是什么', trigger: 'change' }],
        lymph3_direction_radio_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        lymph3_trial_radio: [{ required: true, message: '请选择患者是否愿意参与CAR-T相关的临床试验', trigger: 'change' }],

        lymph3_influence_radio: [{ required: true, message: '请选择长期生存率有何影响', trigger: 'change' }],

        lymph3_study_checkbox: [{ required: true, message: '请选择哪些策略值得研究', trigger: 'change' }],
        lymph3_study_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph3_challenge_checkbox: [{ required: true, message: '请选择最具挑战性的是哪方面', trigger: 'change' }],
        lymph3_challenge_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph3_information_checkbox: [{ required: true, message: '请选择患者更希望了解哪方面的信息', trigger: 'change' }],

        lymph3_knowledge_radio: [{ required: true, message: '请选择治疗知识', trigger: 'change' }],

        lymph3_difference_checkbox: [{ required: true, message: '请选择疗效差异如何', trigger: 'change' }],
        lymph3_difference_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],

        lymph3_trend_checkbox: [{ required: true, message: '请选择您认为未来淋巴瘤治疗的发展趋势是什么', trigger: 'change' }],
        lymph3_trend_checkbox_input: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      }
    }
  },
  created() {
    this.getecholist()
  },
  methods: {
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName("is-error");
        errorDiv[0].scrollIntoView();
      }, 0);
    },
    //提交  
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitApi()
        } else {
          // this.locateToErr(); 
          console.log('error submit!!');
          return false;
        }
      });
    },
    //提交接口
    async submitApi() {
      const { data: data } = await this.$http.post("/survey/info", { id: this.$route.query.id, form: this.form });
      console.log(data);
      this.$toast(data.message);
      this.$router.push({ path: "survey" });
    },
    //回显数据 
    async getecholist() {
      const { data: data } = await this.$http.get("/survey/info", { params: { id: this.$route.query.id } });
      this.form = data.data
    },
  },
}    
</script> 
<style scoped>
.index {
  position: relative;
  left: -15px;
  width: 108.8%;
}

.index-head {
  position: relative;
  width: 375px;
  height: 96px;
  background: url(@/assets/image/survey/head-bgc.png) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;

  color: #130F0F;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  position: relative;
  /* top: -20px; */
  left: 0;
  background-color: #F6F8FF;
  width: 100%;
  box-shadow: 0px 0px 6px 1px #A4C4F1;
  border-radius: 15px 15px 0px 0px;
  min-height: calc(100vh - 142px);
  padding: 20px 15px;
  overflow: hidden;
}

.box-head {
  padding: 20px 12px;
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
}

.box-head-title {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 25px;
}

.box-head-ul {}

.box-head-ul-li {
  color: #2B2B2B;
  font-size: 14px;
  margin-bottom: 22px;
  padding-left: 4px;
}

.box-head-ul-name {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 30px;
}

.form-head-input>>>.el-input__inner {
  /* width: 120px; */
  width: 60%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
  border-color: #130F0F;
}

.form-dis-radio {
  display: flex;
  flex-wrap: wrap;
}

.form-dis-radio>>>.el-radio {
  margin-right: 20px;
}

.form-dis-box {
  position: relative;
}

.form-dis-box-radio {
  position: absolute;
  top: 27px;
  right: -20px;
}

.form-dis-box-radio>>>.el-input__inner {
  /* width: 120px; */
  width: 80%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
}

.form-dis-box-radio>>>.el-form-item__content {
  line-height: 20px !important;
}

.form-dis-box-radio2 {
  position: absolute;
  bottom: -21px;
  right: -20px;
}

.form-dis-radio2>>>.el-radio {
  margin-right: 0px;
}

.form-dis-box-radio2>>>.el-input__inner {
  /* width: 120px; */
  width: 80%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
}

.form-dis-box-radio2>>>.el-form-item__content {
  line-height: 20px !important;
}

/* 1 */
.form-item {
  margin-top: 18px;
  background-color: #fff;
  border-radius: 6px;
  padding: 12px;
}

.box-dis {
  display: flex;
  flex-wrap: wrap;
  /* margin-bottom: 10px; */
  margin-bottom: 0;
}


.box-dis>>>.el-form-item__label {
  width: 100% !important;
  margin-bottom: 10px;
}

.box-dis>>>.el-form-item__content {
  margin-left: 0 !important;
}

.box-dis-input>>>.el-form-item__content {
  margin-left: 0 !important;
}

.box-dis>>>.el-form-item__error {
  top: 94% !important;
}

.box-dis2 {
  margin-bottom: 10px;
}

.box-bottom-15 {
  width: 321px;
  margin-bottom: 10px;
}

.btn {
  margin-top: 38px;
}

.btn-form>>>.el-form-item__content {
  margin-left: 0 !important;
}

.dibu {
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 10px;
}

.dibu-img {
  width: 17px;
  height: 17px;
  margin-right: 4px;
}

.dibu-name {
  color: #000000;
  font-size: 15px;
}

.form-item-error>>>.el-form-item__error {
  min-width: 375px !important;
  top: 80% !important;
}
</style>      